export type OrderSource = 'smt' | 'smm' | 'customer' | 'phone' | 'whatsapp' | 'platform';
export type OrderChannel = 'store' | 'customer-web' | 'whatsapp-phone' | 'delivery-platform';
export type ExternalChannelSource = Exclude<OrderSource, 'smt'>;
export type ServiceMode = 'dine-in' | 'takeaway';

export interface LineServiceMode {
  readonly lineId: string;
  readonly serviceMode: ServiceMode;
}

const ORDER_CHANNEL_BY_SOURCE: Readonly<Record<OrderSource, OrderChannel>> = Object.freeze({
  smt: 'store',
  smm: 'store',
  customer: 'customer-web',
  phone: 'whatsapp-phone',
  whatsapp: 'whatsapp-phone',
  platform: 'delivery-platform',
});

const ORDER_CHANNEL_VALUES: readonly OrderChannel[] = Object.freeze(
  [...new Set(Object.values(ORDER_CHANNEL_BY_SOURCE))],
);

export function canonicalOrderChannelForSource(source: OrderSource): OrderChannel {
  return ORDER_CHANNEL_BY_SOURCE[source];
}

export function isOrderChannel(value: unknown): value is OrderChannel {
  return typeof value === 'string' && ORDER_CHANNEL_VALUES.includes(value as OrderChannel);
}

export interface AuthorityRevisionSet {
  readonly policyVersion: string;
  readonly menuRevision: string;
  readonly availabilityRevision: string;
  readonly pricingRevision: string;
  readonly rulesRevision: string;
}

const assertText = (value: string, code: string): void => {
  if (!value?.trim()) throw new Error(code);
};

export function assertAuthorityRevisionSet(value: AuthorityRevisionSet): void {
  assertText(value.policyVersion, 'AUTHORITY_POLICY_VERSION_REQUIRED');
  assertText(value.menuRevision, 'AUTHORITY_MENU_REVISION_REQUIRED');
  assertText(value.availabilityRevision, 'AUTHORITY_AVAILABILITY_REVISION_REQUIRED');
  assertText(value.pricingRevision, 'AUTHORITY_PRICING_REVISION_REQUIRED');
  assertText(value.rulesRevision, 'AUTHORITY_RULES_REVISION_REQUIRED');
}
